// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2J8iN","title":"Images45_title__3pOz4","images":"Images45_images__9P05N"};